"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonDateRange = exports.OktonTextarea = exports.OktonSelect = exports.OktonCheckbox = exports.OktonInput = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
function errorMessage(error) {
    if (error &&
        typeof error === "object" &&
        !react_2.default.isValidElement(error) &&
        "message" in error) {
        return error.message;
    }
    return error;
}
exports.OktonInput = react_2.default.forwardRef((_a, ref) => {
    var { name, label, error, required, leftIcon, leftElement, rightElement, passwordToggle, type } = _a, props = __rest(_a, ["name", "label", "error", "required", "leftIcon", "leftElement", "rightElement", "passwordToggle", "type"]);
    const [showPassword, setShowPassword] = react_2.default.useState(false);
    const isPassword = type === "password" || passwordToggle;
    const inputType = isPassword && showPassword ? "text" : type;
    return (react_2.default.createElement(react_1.FormControl, { isInvalid: Boolean(error), isRequired: required },
        label ? react_2.default.createElement(react_1.FormLabel, { htmlFor: name }, label) : null,
        react_2.default.createElement(react_1.InputGroup, null,
            leftElement ? (react_2.default.createElement(react_1.InputLeftElement, { pointerEvents: "none" }, leftElement)) : leftIcon ? (react_2.default.createElement(react_1.InputLeftElement, { pointerEvents: "none" },
                react_2.default.createElement(react_1.Icon, { as: leftIcon }))) : null,
            react_2.default.createElement(react_1.Input, Object.assign({ id: name, name: name, ref: ref, type: inputType, rounded: "xl" }, props)),
            isPassword ? (react_2.default.createElement(react_1.InputRightElement, null,
                react_2.default.createElement(react_1.Icon, { as: (showPassword ? lu_1.LuEye : lu_1.LuEyeClosed), cursor: "pointer", onClick: () => setShowPassword((value) => !value) }))) : rightElement ? (react_2.default.createElement(react_1.InputRightElement, { pointerEvents: "none" }, rightElement)) : null),
        error ? (react_2.default.createElement(react_1.FormErrorMessage, null, errorMessage(error))) : null));
});
exports.OktonInput.displayName = "OktonInput";
exports.OktonCheckbox = react_2.default.forwardRef((_a, ref) => {
    var { name, label, error, required } = _a, props = __rest(_a, ["name", "label", "error", "required"]);
    return (react_2.default.createElement(react_1.FormControl, { isInvalid: Boolean(error), isRequired: required },
        react_2.default.createElement(react_1.Checkbox, Object.assign({ id: name, name: name, ref: ref, size: "lg", rounded: "xl" }, props), label),
        error ? react_2.default.createElement(react_1.FormErrorMessage, null, errorMessage(error)) : null));
});
exports.OktonCheckbox.displayName = "OktonCheckbox";
exports.OktonSelect = react_2.default.forwardRef((_a, ref) => {
    var { name, label, error, required, options, placeholder, children } = _a, props = __rest(_a, ["name", "label", "error", "required", "options", "placeholder", "children"]);
    return (react_2.default.createElement(react_1.FormControl, { isInvalid: Boolean(error), isRequired: required },
        label ? react_2.default.createElement(react_1.FormLabel, { htmlFor: name }, label) : null,
        react_2.default.createElement(react_1.Select, Object.assign({ id: name, name: name, ref: ref, rounded: "xl" }, props),
            placeholder ? react_2.default.createElement("option", { value: "" }, placeholder) : null, options === null || options === void 0 ? void 0 :
            options.map((option) => (react_2.default.createElement("option", { key: String(option.value), value: option.value, disabled: option.disabled }, option.label))),
            children),
        error ? react_2.default.createElement(react_1.FormErrorMessage, null, error) : null));
});
exports.OktonSelect.displayName = "OktonSelect";
exports.OktonTextarea = react_2.default.forwardRef((_a, ref) => {
    var { name, label, error, required } = _a, props = __rest(_a, ["name", "label", "error", "required"]);
    return (react_2.default.createElement(react_1.FormControl, { isInvalid: Boolean(error), isRequired: required },
        label ? react_2.default.createElement(react_1.FormLabel, { htmlFor: name }, label) : null,
        react_2.default.createElement(react_1.Textarea, Object.assign({ id: name, name: name, ref: ref, rounded: "xl" }, props)),
        error ? react_2.default.createElement(react_1.FormErrorMessage, null, error) : null));
});
exports.OktonTextarea.displayName = "OktonTextarea";
const OktonDateRange = ({ value, onChange, startLabel = "Data inicial", endLabel = "Data final", isDisabled, }) => (react_2.default.createElement(react_2.default.Fragment, null,
    react_2.default.createElement(exports.OktonInput, { name: "date-start", label: startLabel, type: "date", value: value.start, isDisabled: isDisabled, onChange: (event) => onChange(Object.assign(Object.assign({}, value), { start: event.target.value })) }),
    react_2.default.createElement(exports.OktonInput, { name: "date-end", label: endLabel, type: "date", value: value.end, isDisabled: isDisabled, onChange: (event) => onChange(Object.assign(Object.assign({}, value), { end: event.target.value })) })));
exports.OktonDateRange = OktonDateRange;
//# sourceMappingURL=index.js.map